import * as v from "valibot";

export const getImageSchema = () =>
  v.object({
    originalFilename: v.optional(v.string()),
    currentFilename: v.optional(v.string()),
  });
